<template>
  <div>
    <div :class="{ 'card card-general': fromView !== 'add_invoice' && fromView !== 'add_quotation' }">
      <div
        :class="{
          'card-body': fromView !== 'add_invoice' && fromView !== 'add_quotation',
          'pe-5 ps-5': fromView == 'add_invoice' || fromView == 'add_quotation',
        }"
      >
        <form class="base-form-item form-v2 h-100 d-flex flex-column justify-content-between">
          <div class="w-100">
            <div class="row justify-content-center" style="margin-top: 25px; margin-bottom: 25px;">
              <div class="form-check form-switch col-6">
                <input
                  class="form-check-input parts"
                  type="radio"
                  id="parts"
                  value="parts"
                  v-model="item_form.type"
                />
                <label
                  class="form-check-label"
                  :for="item_form.type === 'parts' ? 'parts' : 'service'"
                  >Parts</label
                >
              </div>
              <div class="form-check form-switch ms-4 col-6">
                <input
                  class="form-check-input services"
                  type="radio"
                  id="services"
                  value="service"
                  v-model="item_form.type"
                />
                <label
                  class="form-check-label"
                  :for="item_form.type === 'service' ? 'service' : 'parts'"
                  >Services</label
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="input-group p-0">
                <div class="input-group-text">
                  <img src="@/assets/images/system/tools_lauren-green.svg" />
                </div>
                <input
                  type="text"
                  name="itemTitle"
                  class="form-control"
                  v-model="item_form.name"
                  placeholder="Type item name or title*"
                />
                <div class="input-group-text transparent p-0 append">
                  <button
                    type="button"
                    name="btn"
                    class="btn btn-white _sm"
                    @click="$emit('show-list-of-items')"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <textarea
                class="form-control"
                v-model="item_form.description"
                placeholder="Parts or Services description"
              ></textarea>
            </div>
          </div>

          <div class="w-100">
            <div class="row m-0 mb-3 d-flex justify-content-end amount-fields">
              <div class="col-sm-9">
                <div class="row mb-3">
                  <div class="input-group group-half p-0">
                    <div class="input-group-text bg-light-orange no-after">
                      Quantity
                    </div>
                    <div class="form-floating">
                      <label class="floating-label _sm _end">(default=1)</label>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control text-right"
                        @blur="calculateAmount"
                        v-model.number="item_form.quantity"
                        v-numeric="{ decimals: 0 }"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="input-group group-half p-0">
                    <div class="input-group-text bg-light-sky no-after">Rate</div>
                    <div class="form-floating">
                      <label class="floating-label">{{ $auth.user?.currency }}</label>
                      <input
                        type="text"
                        inputmode="decimal"
                        class="form-control text-right"
                        v-model.number="item_form.unit_price"
                        @blur="calculateAmount"
                        v-numeric
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="input-group group-half p-0">
                    <div class="input-group-text bg-orange no-after">Amount</div>
                    <div class="form-floating">
                      <label class="floating-label">{{ $auth.user?.currency }}</label>
                      <input
                        type="text"
                        inputmode="decimal"
                        class="form-control text-right"
                        v-model="item_form.amount"
                        v-numeric
                      />
                    </div>
                  </div>
                </div>
                <div class="mt-4 mb-4 me-4 d-flex justify-content-end">
                  <div class="cmn-aw p-0">
                    <button
                      type="button"
                      name="save"
                      class="btn btn-success btn-big _3d-input"
                      @click="createItem"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer">
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddSingleItem",
  props: ["fromView"],
  data() {
    return {
      item_form: {
        type: "parts",
        name: "",
        description: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
      },
      dialogVisibleCategoryPopup: false,
    };
  },
  created() {
    this.$store.commit("item/clearToRecentItems");
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    calculateAmount() {
      // The inputs are free text now, so guard against a half-typed or empty
      // value turning the amount into "NaN".
      const quantity = parseFloat(this.item_form.quantity) || 0;
      const unitPrice = parseFloat(this.item_form.unit_price) || 0;
      this.item_form.amount = (quantity * unitPrice).toFixed(2);
    },
    createItem() {
      if (this.item_form.name.trim() === "") {
        this.$toast.error("Item name is required.");
        return;
      }

      if (this.item_form.quantity <= 0) {
        this.$toast.error("Quantity must be greater than 0.");
        return;
      }

      if (this.item_form.unit_price < 0) {
        this.$toast.error("Unit price cannot be negative.");
        return;
      }

      if (this.item_form.amount <= 0) {
        this.$toast.error("Amount must be greater than 0.");
        return;
      }

      this.$store.commit("item/addToRecentItems", this.item_form);
      this.$nextTick(() => {
        this.item_form = {
          type: "parts",
          name: "",
          description: "",
          quantity: 1,
          unit_price: 0,
          amount: 0,
        };
        this.$emit("closeItemsPopup", true);
      });
    },
    resetForm() {
      this.item_form = {
        type: "parts",
        name: "",
        description: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
      };
    },
    setAddedItemNumber() {
      this.listAddedItemNumber =
        JSON.parse(localStorage.getItem("item_recently_added_items")) || [];
    },
  },
};
</script>

<style scoped>
/* Match the 7px white edge on the right of the Quantity/Rate/Amount inputs */
.amount-fields .input-group.group-half .input-group-text.no-after {
  border-left-width: 7px;
}
</style>
